export const PUBLIC_URL = process.env.PUBLIC_URL as string;
export const API_URL = process.env.REACT_APP_FAPINSTRUCTOR_API as string;
export const NEW_API_URL = process.env
  .REACT_APP_NEW_FAPINSTRUCTOR_API as string;
export const AUTH_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN as string;
export const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID as string;
export const AUTH_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE as string;
export const STATE_CHARTS = process.env.REACT_APP_STATE_CHARTS === "true";
export const TICK_DELAY = 2500;
